
type MenuIcon = {
    active?: boolean;
    action?: (param?: any) => void
}


export function DotsIcon({ active = false, action }: MenuIcon) {
    return (
        <svg
            onClick={() => action && action()}
            width="4" height="12" viewBox="0 0 4 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.3125 11.4375C1.82031 11.4375 1.41016 11.1914 1.16406 10.7812C0.917969 10.3984 0.917969 9.87891 1.16406 9.46875C1.41016 9.08594 1.82031 8.8125 2.3125 8.8125C2.77734 8.8125 3.1875 9.08594 3.43359 9.46875C3.67969 9.87891 3.67969 10.3984 3.43359 10.7812C3.1875 11.1914 2.77734 11.4375 2.3125 11.4375ZM2.3125 7.0625C1.82031 7.0625 1.41016 6.81641 1.16406 6.40625C0.917969 6.02344 0.917969 5.50391 1.16406 5.09375C1.41016 4.71094 1.82031 4.4375 2.3125 4.4375C2.77734 4.4375 3.1875 4.71094 3.43359 5.09375C3.67969 5.50391 3.67969 6.02344 3.43359 6.40625C3.1875 6.81641 2.77734 7.0625 2.3125 7.0625ZM1 1.375C1 0.910156 1.24609 0.5 1.65625 0.253906C2.03906 0.0078125 2.55859 0.0078125 2.96875 0.253906C3.35156 0.5 3.625 0.910156 3.625 1.375C3.625 1.86719 3.35156 2.27734 2.96875 2.52344C2.55859 2.76953 2.03906 2.76953 1.65625 2.52344C1.24609 2.27734 1 1.86719 1 1.375Z" fill="#37393D" />
        </svg>

    )
}